import axios from 'axios';

const authapi = axios.create( {
    baseURL: import.meta.env.TWC_AUTH_URL,
    validateStatus: function( status ) {
        return status >= 200 && status < 500;
    },
} );

export default authapi;
